import { render, staticRenderFns } from "./chatRecordView.vue?vue&type=template&id=1fa88efe&"
import script from "./chatRecordView.vue?vue&type=script&lang=js&"
export * from "./chatRecordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports